/* =========================================================
   Arcbear — Global JS
   ========================================================= */
(function () {
  'use strict';

  const $  = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ----- Sticky header shadow ----- */
  const header = $('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 12);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ----- Drawer helpers ----- */
  const overlay = $('#overlay');
  const openDrawer = (el) => {
    if (!el) return;
    el.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };
  const closeDrawers = () => {
    $$('[data-drawer]').forEach(d => d.classList.remove('is-open'));
    overlay && overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  };
  overlay && overlay.addEventListener('click', closeDrawers);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawers(); });

  $$('[data-drawer-open]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const target = $(btn.dataset.drawerOpen);
      openDrawer(target);
    });
  });
  $$('[data-drawer-close]').forEach(btn => btn.addEventListener('click', closeDrawers));

  /* ----- Hero slider ----- */
  $$('[data-hero]').forEach((hero) => {
    const slides = $$('.hero__slide', hero);
    const dotsWrap = $('.hero__nav', hero);
    if (slides.length < 2) return;
    let idx = 0;
    let timer;
    const interval = parseInt(hero.dataset.autoplay || '6000', 10);

    slides.forEach((s, i) => { s.style.display = i === 0 ? '' : 'none'; });
    if (dotsWrap) {
      dotsWrap.innerHTML = slides.map((_, i) => `<button class="hero__dot${i===0?' is-active':''}" data-i="${i}" aria-label="Slide ${i+1}"></button>`).join('');
      dotsWrap.addEventListener('click', (e) => {
        const dot = e.target.closest('[data-i]');
        if (dot) goTo(parseInt(dot.dataset.i, 10));
      });
    }
    const goTo = (n) => {
      slides[idx].style.display = 'none';
      idx = (n + slides.length) % slides.length;
      slides[idx].style.display = '';
      slides[idx].style.animation = 'fadeUp .9s ease both';
      if (dotsWrap) $$('.hero__dot', dotsWrap).forEach((d, i) => d.classList.toggle('is-active', i === idx));
      restart();
    };
    const next = () => goTo(idx + 1);
    const prev = () => goTo(idx - 1);
    const restart = () => { clearInterval(timer); timer = setInterval(next, interval); };

    $('.hero__arrow--next', hero)?.addEventListener('click', next);
    $('.hero__arrow--prev', hero)?.addEventListener('click', prev);
    restart();
    hero.addEventListener('mouseenter', () => clearInterval(timer));
    hero.addEventListener('mouseleave', restart);
  });

  /* ----- Horizontal slider arrows ----- */
  $$('[data-slider]').forEach((slider) => {
    const track = $('.slider__track', slider);
    const prevBtn = $('[data-slider-prev]', slider);
    const nextBtn = $('[data-slider-next]', slider);
    if (!track) return;
    const scrollAmount = () => track.querySelector('.slider__slide')?.offsetWidth + 20 || 280;
    prevBtn?.addEventListener('click', () => track.scrollBy({ left: -scrollAmount() * 2, behavior: 'smooth' }));
    nextBtn?.addEventListener('click', () => track.scrollBy({ left:  scrollAmount() * 2, behavior: 'smooth' }));
  });

  /* ----- Quantity stepper ----- */
  document.addEventListener('click', (e) => {
    const dec = e.target.closest('[data-qty-dec]');
    const inc = e.target.closest('[data-qty-inc]');
    if (!dec && !inc) return;
    e.preventDefault();
    const wrap = (dec || inc).closest('.qty');
    const input = $('input', wrap);
    const min = parseInt(input.min || '1', 10);
    const max = parseInt(input.max || '99', 10);
    let v = parseInt(input.value || '1', 10);
    v = inc ? Math.min(max, v + 1) : Math.max(min, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ----- AJAX add to cart ----- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    // "Jetzt kaufen" (name=checkout) submits normally → straight to checkout
    if (e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();
    const btn = e.submitter && e.submitter.type === 'submit' ? e.submitter : $('[type="submit"]', form);
    const original = btn?.innerHTML;
    if (btn) { btn.disabled = true; btn.innerHTML = '...'; }
    try {
      const fd = new FormData(form);
      const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('Hinzufügen zum Warenkorb fehlgeschlagen');
      await refreshCart();
      const drawer = $('#cart-drawer');
      openDrawer(drawer);
    } catch (err) { alert(err.message || 'Ein Fehler ist aufgetreten'); }
    finally { if (btn) { btn.disabled = false; btn.innerHTML = original; } }
  });

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      $$('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });
      const sec = await fetch('/?section_id=cart-drawer');
      const html = await sec.text();
      const tmp = document.createElement('div'); tmp.innerHTML = html;
      const newDrawer = tmp.querySelector('#cart-drawer-inner');
      const cur = $('#cart-drawer-inner');
      if (newDrawer && cur) cur.innerHTML = newDrawer.innerHTML;
    } catch (e) { console.warn(e); }
  }
  window.ArcbearRefreshCart = refreshCart;

  /* ----- Cart item update / remove ----- */
  document.addEventListener('click', async (e) => {
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      const key = remove.dataset.cartRemove;
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) });
      await refreshCart();
    }
  });

  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    const key = input.dataset.cartQty;
    const qty = parseInt(input.value, 10);
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
    await refreshCart();
  });

  /* ----- Reveal on scroll ----- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    $$('[data-animate]').forEach(el => io.observe(el));
  }

  /* ----- Tabs ----- */
  $$('[data-tabs]').forEach(group => {
    const btns = $$('.tabs__btn', group);
    const panes = $$('[data-tab-pane]', group);
    btns.forEach(b => b.addEventListener('click', () => {
      btns.forEach(x => x.classList.remove('is-active'));
      panes.forEach(p => p.style.display = 'none');
      b.classList.add('is-active');
      const target = panes.find(p => p.dataset.tabPane === b.dataset.tabTarget);
      if (target) target.style.display = '';
    }));
    btns[0]?.click();
  });

})();
